export const DASHBOARD = {
  COMMISSIONS: 'commissions',
  BALANCE: 'balance',
  COMMISSION_GROUP: 'commissionGroup',
};
